export default "__VITE_PUBLIC_ASSET__bea7e45b__"